export default [{"id":"1","startTime":0,"endTime":3778,"text":"<b>The metal then enters the first machine for punching.</b>"}];